import { defineStore } from 'pinia';

export const useModalNotification = defineStore('modalNotification', {
  state: () => {
    return {
      hasErrors: false,
      hasChanges: false as boolean,
      isModalActive: false as boolean,
    };
  },
  actions: {
    setChanges(b: boolean) {
      this.hasChanges = b;
    },
    setErrors(b: boolean) {
      this.hasErrors = b;
    },
    setIsModalActive(b: boolean) {
      this.isModalActive = b;
    },
    checkChanges() {
      if (this.hasChanges) this.isModalActive = true;
    },
  },
});
